import { render } from "./CreateProductionDocument.vue?vue&type=template&id=66fa86dc"
import script from "./CreateProductionDocument.vue?vue&type=script&lang=js"
export * from "./CreateProductionDocument.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__